import { useMemo } from 'react'
import { nanoid } from 'nanoid'

import { CITATION_LEXICAL_NODES } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/nodes'
import { getEditorStateFromHtml } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/utils'

import { type AIAgentResultState } from '../EditableAIAgentResult/EditableAIAgentResult'

export const useAIAgentResultState = (html?: string | null): AIAgentResultState =>
  useMemo(() => {
    const resultHtml = html ?? ''
    return { html: resultHtml, editorState: getEditorStateFromHtml(resultHtml, CITATION_LEXICAL_NODES), displayId: nanoid() }
  }, [html])
